var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "confirm-modal",
    {
      ref: "modal",
      attrs: {
        title: "Удалить табель",
        confirm: "Удалить",
        reset: "Отменить",
        mode: "danger",
      },
      on: { confirm: _vm.confirm },
    },
    [
      _c("span", [
        _vm.timesheet
          ? _c("span", [
              _vm._v(" Табель "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm.timesheet.filial) +
                    ", " +
                    _vm._s(_vm.timesheet.period.toLowerCase())
                ),
              ]),
              _vm._v(" будет удалён без возможности восстановления "),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }